// ชื่อประเภทรายการคอยน์ (coin_tx.usageType)
export const USAGE_LABEL = {
  message: "ข้อความ", gift: "ของขวัญ", purchase: "เติมเงิน", checkin: "เช็คอินรายวัน", redeem: "ใช้โค้ด", invite: "ชวนเพื่อน",
  monthly: "คอยน์รายเดือนคุยคลับ", admin_adjust: "ปรับยอดโดยทีมงาน", signup: "โบนัสสมัครสมาชิก", note: "พื้นที่โน้ต",
};
export const usageLabel = (t) => USAGE_LABEL[t] || t || "รายการ";
